<template>
  <div class="page-card">
    <div class="section-header">
      <div class="section-header-left">
        <div class="section-title">全部订单</div>
        <div class="search-bar">
          <input
            v-model.trim="searchForm.orderNo"
            class="search-input"
            placeholder="订单号"
            @keyup.enter="handleSearch"
          />
          <input
            v-model.trim="searchForm.projectName"
            class="search-input"
            placeholder="服务项目"
            @keyup.enter="handleSearch"
          />
          <input
            v-model.trim="searchForm.chairName"
            class="search-input"
            placeholder="技师"
            @keyup.enter="handleSearch"
          />
          <input
            v-model.trim="searchForm.hospitalName"
            class="search-input"
            placeholder="门诊"
            @keyup.enter="handleSearch"
          />
          <input
            v-model.trim="searchForm.doctorName"
            class="search-input"
            placeholder="医生"
            @keyup.enter="handleSearch"
          />
          <select v-model="searchForm.status" class="search-input search-select">
            <option value="">全部状态</option>
            <option
              v-for="opt in statusOptions"
              :key="opt.value"
              :value="opt.value"
            >
              {{ opt.label }}
            </option>
          </select>
          <button
            class="search-btn search-btn-reset"
            type="button"
            @click="resetSearch"
          >
            重置
          </button>
          <button
            class="search-btn search-btn-query"
            type="button"
            :disabled="listLoading"
            @click="handleSearch"
          >
            查询
          </button>
        </div>
      </div>
    </div>

    <div v-if="listLoading" class="list-loading">加载中...</div>
    <template v-else>
      <table class="order-table">
        <thead>
          <tr>
            <th class="col-order-id">订单号</th>
            <th>服务项目</th>
            <th>技师</th>
            <th>门诊</th>
            <th>医生</th>
            <th class="col-status">流程状态</th>
            <th class="col-action">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!rows.length">
            <td colspan="7" class="empty-cell">暂无数据</td>
          </tr>
          <tr v-for="item in rows" :key="item.orderId || item.orderNo">
            <td class="cell-order-id">{{ item.orderNo || "-" }}</td>
            <td>
              <span class="service-tag service-tag--blue">
                {{ item.projectName || "-" }}
              </span>
            </td>
            <td>{{ item.chairName || "-" }}</td>
            <td>
              <span class="clinic-tag">{{ item.hospitalName || "-" }}</span>
            </td>
            <td>{{ item.doctorName || "-" }}</td>
            <td class="col-status">{{ statusLabel(item.status) }}</td>
            <td class="col-action">
              <div class="action-btns">
                <button
                  class="action-link"
                  type="button"
                  @click="handleViewDetail(item)"
                >
                  查看详情
                </button>

                <template v-if="Number(item.status) === ORDER_STATUS.PENDING_CONFIRM">
                  <button
                    class="action-link"
                    type="button"
                    @click="handleConfirmOrder(item)"
                  >
                    确认预约
                  </button>
                  <button
                    class="action-link"
                    type="button"
                    @click="handleEdit(item)"
                  >
                    修改
                  </button>
                </template>

                <template v-else-if="Number(item.status) === ORDER_STATUS.IN_PROGRESS">
                  <button
                    class="action-link"
                    type="button"
                    @click="handleApplyReturn(item)"
                  >
                    申请退单
                  </button>
                </template>

                <template v-else-if="Number(item.status) === ORDER_STATUS.RETURN_PENDING">
                  <button
                    class="action-link"
                    type="button"
                    @click="handleConfirmReturn(item)"
                  >
                    确认退单
                  </button>
                  <button
                    class="action-link"
                    type="button"
                    @click="handleReschedule(item)"
                  >
                    重新预约
                  </button>
                </template>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <el-pagination
        v-if="total > 0"
        class="order-pagination"
        small
        layout="total, prev, pager, next"
        :current-page="pageNum"
        :page-size="pageSize"
        :total="total"
        @current-change="onPageChange"
      />
    </template>

    <OrderActionModals ref="orderActions" @success="fetchOrderList" />
  </div>
</template>

<script>
import OrderActionModals from "@/components/order/OrderActionModals.vue";
import { listAllOrders } from "@/api/order";

const SUCCESS_CODE = 20000;

const ORDER_STATUS = {
  PENDING_CONFIRM: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
  RETURN_PENDING: 3,
  RETURN_DONE: 4,
};

const STATUS_OPTIONS = [
  { value: 0, label: "待确认" },
  { value: 1, label: "进行中" },
  { value: 2, label: "订单已完成" },
  { value: 3, label: "退单中" },
  { value: 4, label: "完成退单" },
];

const STATUS_LABEL_MAP = {
  0: "待确认",
  1: "进行中",
  2: "订单已完成",
  3: "退单中",
  4: "完成退单",
};

function createEmptySearchForm() {
  return {
    orderNo: "",
    projectName: "",
    chairName: "",
    hospitalName: "",
    doctorName: "",
    status: "",
  };
}

export default {
  name: "AllOrderList",
  components: {
    OrderActionModals,
  },
  data() {
    return {
      ORDER_STATUS,
      statusOptions: STATUS_OPTIONS,
      listLoading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      searchForm: createEmptySearchForm(),
      rows: [],
    };
  },
  mounted() {
    this.fetchOrderList();
  },
  methods: {
    showMessage(type, text) {
      this.$message({ message: text, type });
    },
    isBizError(res) {
      return res && res.code != null && Number(res.code) !== SUCCESS_CODE;
    },
    statusLabel(status) {
      const key = Number(status);
      return STATUS_LABEL_MAP[key] || "-";
    },
    resolveListPayload(data) {
      if (Array.isArray(data)) {
        return { list: data, total: data.length };
      }
      if (!data || typeof data !== "object") {
        return { list: [], total: 0 };
      }
      const list = data.list || data.records || data.rows || [];
      const total = Number(data.total ?? list.length) || 0;
      return { list: Array.isArray(list) ? list : [], total };
    },
    mapOrderRow(item) {
      if (!item || typeof item !== "object") return null;
      const orderId = String(item.orderId ?? item.id ?? "").trim();
      const orderNo = String(item.orderNo ?? item.orderCode ?? orderId).trim();
      if (!orderId && !orderNo) return null;

      const projectCode = String(item.projectCode ?? "").trim();
      const projectNameRaw = String(item.projectName ?? "").trim();
      const projectName =
        projectCode && projectNameRaw
          ? `${projectCode} ${projectNameRaw}`
          : projectNameRaw || projectCode;

      return {
        orderId: orderId || orderNo,
        orderNo: orderNo || orderId,
        projectName,
        chairName: String(item.chairName ?? "").trim(),
        hospitalName:
          String(item.hospitalName ?? "").trim() ||
          String(item.hospitalCode ?? "").trim(),
        doctorName: String(item.doctorName ?? "").trim(),
        status: item.status,
        raw: item,
      };
    },
    async fetchOrderList() {
      this.listLoading = true;
      try {
        const res = await listAllOrders({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          orderNo: this.searchForm.orderNo,
          projectName: this.searchForm.projectName,
          chairName: this.searchForm.chairName,
          hospitalName: this.searchForm.hospitalName,
          doctorName: this.searchForm.doctorName,
          status: this.searchForm.status,
        });
        if (this.isBizError(res)) {
          this.showMessage("error", res.msg || "订单列表加载失败");
          this.rows = [];
          this.total = 0;
          return;
        }
        const payload = this.resolveListPayload(res && res.data);
        this.rows = payload.list.map((item) => this.mapOrderRow(item)).filter(Boolean);
        this.total = payload.total;
      } catch (error) {
        const msg =
          (error && error.msg) || error.message || "订单列表加载失败，请稍后重试";
        this.showMessage("error", msg);
        this.rows = [];
        this.total = 0;
      } finally {
        this.listLoading = false;
      }
    },
    onPageChange(page) {
      this.pageNum = page;
      this.fetchOrderList();
    },
    handleSearch() {
      this.pageNum = 1;
      this.fetchOrderList();
    },
    resetSearch() {
      this.searchForm = createEmptySearchForm();
      this.pageNum = 1;
      this.fetchOrderList();
    },
    handleViewDetail(item) {
      this.$refs.orderActions && this.$refs.orderActions.viewDetail(item);
    },
    handleConfirmOrder(item) {
      this.$refs.orderActions && this.$refs.orderActions.confirmOrderAction(item);
    },
    handleEdit(item) {
      this.$refs.orderActions && this.$refs.orderActions.editOrder(item);
    },
    handleApplyReturn(item) {
      this.$refs.orderActions && this.$refs.orderActions.applyReturn(item);
    },
    handleConfirmReturn(item) {
      this.$refs.orderActions && this.$refs.orderActions.confirmReturnAction(item);
    },
    handleReschedule(item) {
      this.$refs.orderActions && this.$refs.orderActions.rescheduleOrderAction(item);
    },
  },
};
</script>

<style scoped>
.page-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 12px;
  flex-wrap: wrap;
}

.section-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
  flex-wrap: wrap;
}

.section-title {
  font-size: 18px;
  color: #333;
  margin: 0;
  font-weight: 600;
  white-space: nowrap;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.search-input {
  width: 120px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
}

.search-select {
  width: 130px;
  background: #fff;
}

.search-input:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
}

.search-input::placeholder {
  color: #bfbfbf;
}

.search-btn {
  height: 32px;
  padding: 0 14px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
}

.search-btn-reset {
  background: #fff;
  color: #5c6b7f;
  border: 1px solid #d9d9d9;
}

.search-btn-reset:hover {
  color: #409eff;
  border-color: #409eff;
}

.search-btn-query {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}

.search-btn-query:hover:not(:disabled) {
  background: #096dd9;
  border-color: #096dd9;
}

.search-btn-query:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.list-loading,
.empty-cell {
  padding: 40px 0;
  text-align: center;
  color: #999;
  font-size: 14px;
}

.order-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: 1px solid #eef1f6;
}

.order-table th,
.order-table td {
  border-bottom: 1px solid #eef1f6;
  padding: 14px 12px;
  font-size: 14px;
  color: #3f4a5d;
  vertical-align: middle;
  text-align: left;
}

.order-table th {
  background: #f8f9fc;
  color: #616f84;
  font-weight: 600;
}

.order-table tbody tr:hover td {
  background: #f0f7ff;
}

.order-table .col-order-id {
  width: 150px;
}

.order-table .col-status {
  width: 110px;
  color: #333;
}

.order-table .col-action {
  width: 240px;
}

.cell-order-id {
  font-weight: 700;
  color: #2f3a4c;
}

.service-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 20px;
}

.service-tag--blue {
  background: #e6f4ff;
  color: #1677ff;
}

.clinic-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  background: #f5f5f5;
  color: #595959;
  font-size: 12px;
  line-height: 20px;
}

.action-btns {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.action-link {
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  font-size: 13px;
  color: #1890ff;
  cursor: pointer;
  line-height: 1.4;
}

.action-link:hover {
  color: #40a9ff;
}

.order-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
